import { Component, Input, OnInit } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { environment } from '../../../../environments/environment';
import { ChatMessage } from '@models/chat-message';
import { ChatMessageService } from '@services/cms/chat-message.service';
import { ChatMessageClass } from '@classes/chat-message.class';
import { NotificationFacade } from '@redux/notification.facade';
import { Live } from '@models/live';
declare var configurations: any;

@Component({
  selector: 'app-card-chat',
  templateUrl: './card-chat.component.html',
  styleUrls: ['./card-chat.component.scss']
})
export class CardChatComponent implements OnInit {
  @Input() public live: Live | null = null;
  private connection: any | null = null;
  public liveID = 0;
  public liveBroadcastID = '';
  // public service: AbstractService;
  public messages: ChatMessage[] = [];
  public messageTxt = '';
  public replyMessageVar = false;

  constructor(
      public notificationFacade: NotificationFacade,
      public service: ChatMessageService
  ) {
    this.service.modelClass.model['liveID'] = this.liveID;
  }

  ngOnInit(): void {
    if (this.live !== null) {
      console.log(this.live);
      this.liveID = this.live.liveID;
      this.liveBroadcastID = this.live.liveBroadcastID;
      this.getAllMessages(this.live.liveID);
      this.connection = new signalR.HubConnectionBuilder()
          .configureLogging(signalR.LogLevel.Information)
          .withUrl(configurations.url_env + 'livechat', {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
          })
          .build();

      this.connection.start().then(() => {
        /* console.log('TESTESTEST');
        console.log('SignalR Connected!');
        console.log(this.liveBroadcastID);
        this.connection.invoke('AddToGroup', this.liveBroadcastID); */
      }).catch((err: any) => {
        this.notificationFacade.setError('Error conectandose al chat');
        return console.error(err.toString());
      });
      try {
        this.connection.on('ReceiveMessage', (data: ChatMessage) => {
          this.messages.push(data);
          setTimeout(() => {
            const myDiv = document.getElementById('chat-messages');
            if (myDiv !== null) {
              myDiv.scrollTop = myDiv.scrollHeight;
            }
          }, 50);
        });
        this.connection.onclose(async () => {
          console.log('close');
        });
      } catch (err) {
        this.notificationFacade.setError('Hubo un error enviando el mensaje');
      }
    }
  }

  public getAllMessages = async (id: number) => {
    this.service.getByLiveID(id).then((data) => {
      if (data !== false) {
        this.messages.push(...this.service.data.data);
      }
    });
  }

  sendMessage = async () => {
    if (!this.replyMessageVar) {
      this.service.modelClass.model.reply = null;
      this.service.modelClass.model.replyToMessageID = null;
    }
    console.log(this.live?.topic?.name);
    this.service.modelClass.model.userMSG.name = this.live?.topic?.name;
    this.service.modelClass.model.userMSG.email = this.live?.topic?.email;
    this.service.modelClass.model.liveBroadcastID = this.liveBroadcastID;
    const msg = this.service.modelClass.model;
    try {
      await this.connection.invoke('SendMessageAsync', msg);
      this.service.modelClass = new ChatMessageClass();
      this.replyMessageVar = false;
    } catch (err) {
      this.notificationFacade.setError('Hubo un error enviando el mensaje');
    }
  }

  replyMessage = (message: ChatMessage) => {
    if (!message.isBrand) {
      this.replyMessageVar = true;
      this.service.modelClass.model.replyToMessageID = message.liveChatMessageID;
      this.service.modelClass.model.reply = {
        userMSG: {
          name: message.userMSG.name,
          email: message.userMSG.email,
        },
        txtMessage: message.txtMessage
      };
    }
  }

  deleteReplyMessage = () => {
    this.replyMessageVar = false;
    this.service.modelClass.model.reply = null;
  }

  blockUser = (user: any) => {
     this.service.blockUser(user , this.liveID).then((response) => {
      console.log(response);
    });
  }
}
